import { GET_WORKSPACE_CATEGORY } from './index';

export const getWorkspaceCategoryAction = (workspace_category) => ({
    type: GET_WORKSPACE_CATEGORY,
    workspace_category
});